/* eslint-disable react/prop-types */
import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { profileViewSlice } from '../../../store/profileView'

import LoadingIndicator from '../../elements/LoadingIndicator'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import TableSortLabel from '@mui/material/TableSortLabel'
import { descendingComparator } from '../../../constants/constants'
import { secondsToTime } from '../../../utils/baseStringUtils'

const getComparator = (order) => {
  return order === 'desc' ? (a, b) => descendingComparator(a, b) : (a, b) => -descendingComparator(a, b)
}

function ActivityHeader (props) {
  const order = props.order

  const createSortHandler = (property) => (event) => {
    props.onRequestSort(event, property)
  }

  const renderHeader = () => {
    const activityLabel = <Typography variant='caption' width='100%'>activity</Typography>

    return (
      <TableHead>
        <TableRow>
          <TableCell key='date'>
            <TableSortLabel active direction={order} onClick={createSortHandler('date')}>
              Date
            </TableSortLabel>
          </TableCell>

          <TableCell align='center' className='odd-col'>Steps</TableCell>
          <TableCell align='center'>Light {activityLabel}</TableCell>
          <TableCell align='center' className='odd-col'>Moderate {activityLabel}</TableCell>
          <TableCell align='center'>Intense {activityLabel}</TableCell>
        </TableRow>
      </TableHead>
    )
  }

  return renderHeader()
}

function ActivityRow (props) {
  const dateAsMoment = moment(props.date)
  const formattedDate = moment().isSame(dateAsMoment, 'year') ? dateAsMoment.format('MMM DD') : dateAsMoment.format('MMM DD, YYYY')

  // sort the measurements in asc or desc based on date sort
  props.data.measurements.sort((a, b) => props.order === 'desc' ? descendingComparator(a.date, b.date) : -descendingComparator(a.date, b.date))

  const renderRow = () => {
    return (
      <>
        {props.data?.measurements.map(measurement => {
          return (
            <TableRow sx={{ backgroundColor: theme => `${theme.palette.background.paper}!important` }} key={measurement.date}>
              <TableCell> <Typography display='flex'> {formattedDate} </Typography> </TableCell>
              <TableCell align='center' className='odd-col'>{measurement.steps}</TableCell>
              <TableCell align='center'>{secondsToTime(measurement.intensities.light.value)}</TableCell>
              <TableCell align='center' className='odd-col'>{secondsToTime(measurement.intensities.moderate.value)}</TableCell>
              <TableCell align='center'>{secondsToTime(measurement.intensities.intense.value)}</TableCell>
            </TableRow>
          )
        })}
      </>
    )
  }

  return renderRow()
}

function ActivityTable (props) {
  const [order, setOrder] = React.useState('asc')
  const handleRequestSort = () => setOrder(order === 'asc' ? 'desc' : 'asc')

  const groupByDate = (data, alerts) => {
    const groupedData = {}

    data.forEach((d) => {
      if (!groupedData[d.date]) groupedData[d.date] = { measurements: [] }
      const newItem = {
        ...d
      }
      groupedData[d.date].measurements.unshift(newItem)
    })
    return groupedData
  }

  const renderTable = () => {
    if (props.dashboardViewStore.isRangeLoading) {
      return (
        <div className='metrics-section__inner'> <LoadingIndicator /> </div>
      )
    }

    const dataSection = props.memberObj.activity
    if (!dataSection?.data?.length) {
      return (
        <Box>
          <Typography variant='body1' color='#7f7f7f' marginTop={1.5}>No activity data for this period</Typography>
        </Box>
      )
    }

    const dataByDate = groupByDate(dataSection.data, props.memberObj.alerts)
    const sectionClass = !props.hideBorder ? 'metrics-section' : ''
    return (
      <TableContainer className={sectionClass} sx={{ height: 408 }}>
        {!props.hideHeader && <h3 className='metrics-section__header'>Activity</h3>}
        <Table className='blood-pressure-table__container' stickyHeader>
          <ActivityHeader order={order} onRequestSort={handleRequestSort} />
          <TableBody>
            {Object.keys(dataByDate).slice().sort(getComparator(order)).map((date, i) => {
              return <ActivityRow order={order} date={date} data={dataByDate[date]} key={i} actions={props.profileViewActions} />
            })}
          </TableBody>
        </Table>
      </TableContainer>
    )
  }

  return renderTable()
}

function getPropsFromActions (dispatch) {
  return {
    profileViewActions: bindActionCreators(profileViewSlice.actions, dispatch)
  }
}

export default connect(null, getPropsFromActions)(ActivityTable)
